/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_line_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Add more numeric columns and each becomes its own line with a colour and legend entry.`)
};

const es_line_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Añade más columnas numéricas y cada una se convierte en su propia línea con un color y una entrada en la leyenda.`)
};

const de_line_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Fügen Sie weitere numerische Spalten hinzu, und jede wird zu einer eigenen Linie mit Farbe und Legendeneintrag.`)
};

const nl_line_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Voeg meer numerieke kolommen toe en elke kolom wordt zijn eigen lijn met een kleur en legenda-item.`)
};

const fr_line_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Ajoutez plus de colonnes numériques et chacune devient sa propre courbe avec une couleur et une entrée de légende.`)
};

const it_line_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Aggiungi più colonne numeriche e ciascuna diventa una propria linea con un colore e una voce di legenda.`)
};

const pt_br2_line_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Adicione mais colunas numéricas e cada uma se torna sua própria linha com uma cor e um item na legenda.`)
};

const pt_line_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Adicione mais colunas numéricas e cada uma torna-se a sua própria linha com uma cor e entrada de legenda.`)
};

const ja_line_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。数値列を追加すると、それぞれが色と凡例エントリを持つ独自の線になります。`)
};

const zh_line_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。添加更多数值列，每列都会成为一条带颜色和图例条目的独立线条。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const line_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.line_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("line_faq_a2", locale)
	if (locale === "en") return en_line_faq_a2(inputs)
	if (locale === "es") return es_line_faq_a2(inputs)
	if (locale === "de") return de_line_faq_a2(inputs)
	if (locale === "nl") return nl_line_faq_a2(inputs)
	if (locale === "fr") return fr_line_faq_a2(inputs)
	if (locale === "it") return it_line_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_line_faq_a2(inputs)
	if (locale === "pt") return pt_line_faq_a2(inputs)
	if (locale === "ja") return ja_line_faq_a2(inputs)
	return zh_line_faq_a2(inputs)
};